import {Component, OnInit} from '@angular/core';
import {DataExchangeService} from '../../../../../surface3d/src/lib/API/Public/data-exchange.service';


@Component({
    selector: 'burncase-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {

    constructor(public dataExchangeService: DataExchangeService) {
    }

    ngOnInit(): void {
    }

}
